/**
 * Returns the remainder of two numbers.
 *
 * @param dividend - The number to divide.
 * @param divisor - The number to divide with.
 *
 * @returns The remainder of the two numbers.
 */
export var modulo = function modulo(dividend, divisor) {
  return dividend % divisor;
};